import { styled } from '@mui/system';

export const CustomActionContainer = styled('div')``

export const CustomActionButton = styled('div')``

export const CustomActionList = styled('div')<{quad: boolean}>`
  display: grid;
  grid-template-rows: auto auto;
  margin-top: 30px;
  
  ${props => props.theme.breakpoints.up('laptop')}{
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  
  ${props => props.theme.breakpoints.down('laptop')}{
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  ${CustomActionContainer}{
    text-align: center;
    max-width: 600px;
    margin: auto;
  }
`

export const DesktopActionCard = styled('div')`
  display: flex;
`